module.exports = __webpack_public_path__ + "img/aimax.db2876b6.png";